import {
  Typography,
  CircularProgress,
  makeStyles,
  IconButton,
} from '@material-ui/core';
import { RemoveCircle } from '@material-ui/icons';
import { FileTypeIcons } from 'components/Common/DynamicIcon';
import { get } from 'lodash';
import React from 'react';
import { uploadFile } from 'services/files';
import { cellDataFormatter } from 'util/TableDataFormatters';

const useStyles = makeStyles((theme) => ({
  colorPrimary: {
    color: '#ffffff',
  },
}));

const FilesDataCell = ({
  row,
  column,
  rowState,
  handleDeeplink,
  baseDeepLink,
  rowIndex,
  handleRowChange,
  rowKey,
  fetchRows,
  setMessage,
}) => {
  const classes = useStyles();
  const [uploading, setUploading] = React.useState(false);
  const [err, setErr] = React.useState(false);

  const submitFile = (data, file) => {
    const requestBody = {
      files: [
        ...(rowState[column.key] || (row[column.key] || {}).files),
        {
          comments: data.comments || '',
          fileUrl: data.fileUrl,
          time: data.time,
          fileType: file.type,
          fileName: file.name,
        },
      ],
    };

    // handleRowChange(row.id, { [column.key]: [...(rowState[column.key]||(row[column.key]||{}).files), ...(requestBody.files||{})] })
    handleDeeplink(`${baseDeepLink}/${row.id}/files`, 3, requestBody)
      .then((data) => {
        setUploading(false);
        data.refreshDeeplink && fetchRows(data.refreshDeeplink);
        data.userMessage && setMessage(data.userMessage);
      })
      .catch(console.log);
  };

  const removeFile = (selectedFile) => {
    const requestBody = {
      files: (
        rowState[column.key] ||
        (row[column.key] || {}).files ||
        []
      ).filter(
        (file) =>
          file.fileUrl !== selectedFile.fileUrl &&
          file.time !== selectedFile.time
      ),
    };

    handleDeeplink(`${baseDeepLink}/${row.id}/files`, 3, requestBody)
      .then((data) => {
        setUploading(false);
        data.refreshDeeplink && fetchRows(data.refreshDeeplink);
        data.userMessage && setMessage(data.userMessage);
      })
      .catch(console.log);
  };

  return (
    <div>
      <div
      // style={{
      //   maxHeight: 100,
      //   overflow: 'scroll',
      //   border: '1px solid #e8e8e8',
      //   paddingLeft: 5,
      // }}
      >
        {(
          (rowState || {})[column.key] ||
          (row[column.key] || {}).value ||
          []
        ).map((file) => (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <a
              href={file.fileUrl}
              style={{
                textDecoration: 'none',
                color: '#808080',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'baseline',
                width: '90%',
                height: '100%'
              }}
              target="_blank"
            >
              <div style={{ width: 25 }}>
                <FileTypeIcons
                  type={file.fileType}
                  style={{ width: 16, height: 16 }}
                />
              </div>
              <Typography
                noWrap
                style={{ fontSize:16, textOverflow: 'ellipsis', width: '80%' }}
              >
                {file.fileName}
              </Typography>
            </a>
            {(row[column.key] || {}).cellEditable !== false && (
              <IconButton onClick={() => removeFile(file)}>
                <RemoveCircle style={{ color: '#b70000', fontSize: 17.5 }} />
              </IconButton>
            )}
          </div>
        ))}
      </div>
      {(row[column.key] || {}).cellEditable !== false && (
        <label class="custom-file-upload">
          <input
            type="file"
            style={{ display: 'none' }}
            onChange={(e) =>
              uploadFile(
                e.target.files[0],
                () => setUploading(true),
                submitFile,
                (error = {}) => {
                  setUploading(false);
                  setMessage(error.userMessage || error.errorMessage);
                }
              )
            }
          />
          <div
            style={{
              // width: '100%',
              display: 'inline-block',
              textAlign: 'center',
              cursor: 'pointer',
              marginTop: 10,
              border: 'none',
              background:
                'transparent linear-gradient(240deg, #7467F0 0%, #2896E9 100%) 0% 0% no-repeat padding-box',
              borderRadius: 5,
              padding: '10px 15px 10px 15px',
              color: '#ffffff',
              width: 100,
              // fontSize:'1rem'
            }}
          >
            {uploading ? (
              <CircularProgress
                classes={{
                  colorPrimary: classes.colorPrimary,
                }}
                size={25}
              />
            ) : (
              '+ Add File'
            )}
          </div>
        </label>
      )}
    </div>
  );
};

export default FilesDataCell;
